module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/506c5a55f7956d6548af06160f800ecc.png";